import useAppFeedbackRepo from '@/composables/app-feedback/app-feedback-repo';
import useLoggedInUser from '@/composables/logged-in-user/logged-in-user';
import useLoggedInUserAccount from '@/composables/logged-in-user-account/logged-in-user-account';
import useMe from '@/composables/me';

import { canDisplayAppFeedback } from '@/composables/app-feedback/show-app-feedback';

export default function useAppFeedback() {
  const { loggedInUser } = useLoggedInUser();
  const { loggedInUserAccount } = useLoggedInUserAccount();
  const { appFeedbackHistory } = useMe();
  const repo = useAppFeedbackRepo();

  return {
    canDisplayAppFeedback: () => canDisplayAppFeedback(loggedInUserAccount.value, loggedInUser.value, appFeedbackHistory.value),
    mutateAppFeedback: repo.mutateSingle,
  };
}
